enum ContractStatusEnum {
  COMPLETED = 'completed',
  UNREALIZED = 'unrealized',
  INITIAL = 'initial',
  ACTIVE = 'active',
  PENDING = 'pending',
  TERMINATED = 'terminated',
}

enum contractsPoints {
  GET_CONTRACTS = 'pfdod/contract/list',
  ASSIGN_CONTRACT = 'pfdod/contract/activate',
}

interface Contract {
  id: Id; // ID
  serial: Id; // Номер договора
  order_id: Id; // ID заявки
  kid_id: Id; // ID ребенка
  partner_name: string; // Наименование организации
  partner_id: Id; // Id организации
  event_name: string; // Наименование программы
  event_image: string; // Изображение программы
  event_location: string; // Адрес программы
  event_id: Id; // Id программы
  group_name: string; // Наименование группы
  group_id: Id; // Id группы
  created: ContractDate; // Дата формирования
  start_date_plan: ContractDate; // Дата начала обучения
  end_date_plan: ContractDate; // Дата окончания обучения (план)
  amount_plan: string; // Объем услуг в рублях (план)
  duration_plan: string; // Объем услуг в часах (план)
  end_date_fact: ContractDate; // Дата окончания обучения (факт)
  amount_fact: string; // Объем услуг в рублях (факт)
  duration_fact: string; // Объем услуг в часах (факт)
  status: ContractStatusEnum; // Статус
  download_link: string; // Ссылка на скачивание заполненного договора.
}

type ContractDate = Date | string | number;
type Id = string | number;
type ContractsType = Array<Contract>;

export { Contract, ContractsType, ContractDate, contractsPoints };



// WEBPACK FOOTER //
// ./src/services/contracts/types.ts